import { z } from "zod";
export const NpmProxyTokenPayload = z.object({
    npmProxyRegistryConfigId: z.string(),
});
